import { DATA_CARD_ONE_LOGO_DEFAULT, PACA_CLIMATE_CHANGE_ICON, PACA_GENDER_ICON, PACA_GOBER_ICON, PACA_OTHERS_ICON, PACA_PERSON_ICON, PACA_PROSPERITY_ICON, PACA_SEA_ICON, SINIA_ICON } from "../assets";
import { STATISTICS_DETAIL } from "./routes";

export const CARD_LIST_V2 = [
  {
    id: "0",
    name: "MINAE (Ministerio de Ambiente y Energía)",
    title: "MINAE <sep> (Ministerio de Ambiente y Energía)",
    showOnMenu: true,
    category_id: "",
    description:
      "Encargado de la publicación de información de las diferentes dependencias del Ministerio de Ambiente y Energía, corresponde al proceso mediante el cual cada dirección, departamento, programa o unidad pone a disposición del público los datos, indicadores, mapas, informes y productos generados en el ejercicio de sus funciones. Este proceso tiene como finalidad garantizar la transparencia, facilitar el acceso a la información ambiental y fortalecer la toma de decisiones, asegurando que la información publicada sea oportuna, actualizada y coherente.",
    icon_url: "",
    open_data_link: STATISTICS_DETAIL.replace(":id", "0"),
    metadata: {
      version: "1.0.0",
    },
    elements: [
      {
        title: "Contraloría Ambiental (CA)",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21754/contraloria-ambiental-ca",
      },
      {
        title: "Dirección de Agua (DA)",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21753/direccion-de-agua-da",
      },
      {
        title: "Dirección de Energía (DE)",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21755/direccion-de-energia-de/",
      },
      {
        title: "Dirección de Energía (DE) / BALANCE ENERGETICO 2022",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21694/balance-energetico-nacional-2022",
      },
      {
        title: "Dirección de Geología y Minas (DGM)",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21752/direccion-de-geologia-y-minas-dgm/",
      },
      {
        title: "Fondo Nacional de Financiamiento Forestal (FONAFIFO)",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21751/fondo-nacional-de-financiamiento-forestal-fonafifo/",
      },
      {
        title: "Sistema Nacional de Áreas de Conservación (SINAC)",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21750/sistema-nacional-de-areas-de-conservacion-sinac",
      },
    ],
  },
  {
    id: "1",
    name: "INSTITUCIONES (otras de la Red Nacional Ambiental (RENIA) ",
    title:
      "INSTITUCIONES <sep> (otras de la Red Nacional Ambiental <sep> (RENIA)",
    category_id: "",
    description:
      "Proceso mediante el cual entidades públicas, autónomas, académicas u otras organizaciones con competencia o información relevante en materia ambiental y que integran la RENIA, ponen a disposición del SINIA los datos, indicadores, mapas, informes, o productos generados en el marco de sus funciones. Esta acción busca fortalecer la integración y el intercambio interinstitucional de información ambiental, promoviendo la transparencia, la colaboración y la toma de decisiones informadas en el ámbito de la gestión ambiental nacional.",
    icon_url: "",
    open_data_link: STATISTICS_DETAIL.replace(":id", "1"),
    showOnMenu: true,
    metadata: {
      version: "1.0.0",
    },
    elements: [
      {
        title: "Banco Central de Costa Rica (BCCR)",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21763/banco-central-de-costa-rica-bccr/",
      },
      {
        title: "Instituto Costarricense de Pesca y Acuacultura (INCOPESCA)",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21756/instituto-costarricense-de-pesca-y-acuicultura-incopesca",
      },
      {
        title: "Instituto Nacional de Estadística y Censos (INEC)",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21762/instituto-nacional-de-estadistica-y-censos-inec",
      },
      {
        title: "Ministerio de Agricultura y Ganadería de Costa Rica (MAG)",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21761/ministerio-de-agricultura-y-ganaderia-de-costa-rica-mag",
      },
      {
        title: "Ministerio de Salud (MINSA)",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21768/ministerio-de-salud-de-costa-rica-minsa",
      },
      {
        title: "Ministerio de Vivienda y Urbanismo (MIVAH)",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21757/ministerio-de-vivienda-y-asentamientos-humanos-mivah",
      },
      {
        title:
          "Comisión Nacional de Prevención de Riesgos y Atención de Emergencias (CNE)",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21760/comision-nacional-de-prevencion-de-riesgos-y-atencion-de-emergencias-cne",
      },
      {
        title: "Ministerio de Educación Pública (MEP)​",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21759/ministerio-de-educacion-publica-mep",
      },
      {
        title: "Instituto Costarricense de Turismo (ICT)",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21758/instituto-costarricense-de-turismo-ict",
      },
    ],
  },
  {
    id: "2",
    name: "PROYECTOS AMBIENTALES",
    title: "PROYECTOS AMBIENTALES",
    category_id: "",
    description:
      "Publica información y datos relevantes para el país con fundamento en el Artículo 13 del Decreto Ejecutivo No.45138 MINAE, generada por distintos proyectos, iniciativas, programas o acciones orientadas a la protección, conservación, restauración,  manejo y uso sostenible de los recursos naturales, así como la gestión responsable del medio ambiente.",
    icon_url: "",
    open_data_link: STATISTICS_DETAIL.replace(":id", "2"),
    showOnMenu: true,
    metadata: {
      version: "1.0.0",
    },
    elements: [
      {
        title: "PACA",
        iconSrc: SINIA_ICON,
        subitems: true,
        href: STATISTICS_DETAIL.replace(":id", "3"),
      },
      {
        title: "MOCUPP",
        iconSrc: SINIA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21781/mocupp",
      },
    ],
  },
  {
    id: "3",
    name: "Pacífico Costero Centroamericano",
    title: "Pacífico Costero Centroamericano",
    category_id: "",
    description:
      "Esta sección presenta indicadores sobre el estado de salud del Gran Ecosistema Marino del Pacífico Costero Centroamericano (GEM PACA). Fue desarrollada en el marco de la iniciativa Pacífico Sostenible, implementada por PNUD a través de WWF y financiada por el GEF, con el propósito de fortalecer la gestión conjunta del GEM PACA y sentar bases que permitan su actualización y uso continuo. Países participantes: México, Guatemala, Honduras, Costa Rica, Panamá, Colombia y Ecuador. Desarrollado en el marco de la iniciativa Pacífico Sostenible (PNUD, WWF, GEF), con la participación de México, Guatemala, Honduras, Costa Rica, Panamá, Colombia y Ecuador.",
    icon_url: "",
    bannerImageSrc: DATA_CARD_ONE_LOGO_DEFAULT,
    whereWorkdShow: true,
    open_data_link: "",
    showOnMenu: false,
    metadata: {
      version: "1.0.0",
    },
    elements: [
      {
        title: "Cambio climático",
        iconSrc: PACA_CLIMATE_CHANGE_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21764/cambio-climatico",
      },
      {
        title: "Género",
        iconSrc: PACA_GENDER_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21765/genero",
      },
      {
        title: "Personas",
        iconSrc: PACA_PERSON_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21744/personas",
      },
      {
        title: "Prosperidad",
        iconSrc: PACA_PROSPERITY_ICON,
        subitems: false,
        href: "http://ceniga.opendata.junar.com/dashboards/21766/prosperidad",
      },
      {
        title: "Mares y costas",
        iconSrc: PACA_SEA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21767/mares-y-costas",
      },
      {
        title: "Gobernanza",
        iconSrc: PACA_GOBER_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21743/gobernanza",
      },
      {
        title: "Otros recursos",
        iconSrc: PACA_OTHERS_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21782/paca-mapas",
      },
    ],
  },
];

export const CARD_LIST = [
  {
    metadata: {
      version: "1.0.0",
    },
    description: "Listado de los indicadores relacionados con el océano",
    id: "16f84d34-e4c7-44a5-82e5-ec8a4492450f",
    name: "Océano",
    category_id: "16f84d34-e4c7-44a5-82e5-ec8a4492450f",
    icon_url:
      "https://indicator-data.s3.us-east-1.amazonaws.com/icon/oceano+1.svg",
    open_data_link:
      "https://ceniga.opendata.junar.com/dashboards/21693/oceano/",
  },
  {
    metadata: null,
    description: "",
    id: "3bd19b0e-452d-453b-a577-819e57091b02",
    name: "Agua y Saneamiento",
    icon_url: "https://indicator-data.s3.amazonaws.com/icon/agua_icon.svg",
    category_id: "3bd19b0e-452d-453b-a577-819e57091b02",
    open_data_link:
      "https://ceniga.opendata.junar.com/dashboards/21690/agua-y-saneamiento/",
  },
  // {
  //   "metadata": {
  //     "version": "1.0.0"
  //   },
  //   "description": "Listado de los indicadores relacionados con acciones por el clima",
  //   "id": "2336217d-3300-4c35-8b2b-d78b526f7cb0",
  //   "name": "Acción por el clima",
  //   "category_id": "2336217d-3300-4c35-8b2b-d78b526f7cb0"
  // },
  {
    metadata: null,
    description: "",
    id: "6032cbe8-b299-453f-81aa-5c13efffeec5",
    name: "Biodiversidad y servicios ecosistémicos",
    icon_url: "https://indicator-data.s3.amazonaws.com/icon/ecosistema.svg",
    category_id: "6032cbe8-b299-453f-81aa-5c13efffeec5",
    open_data_link:
      "https://ceniga.opendata.junar.com/dashboards/21697/biodiversidad-y-servicios-ecosistemicos/",
  },
  // {
  //   "metadata": {
  //     "version": "1.0.0"
  //   },
  //   "description": "Listado de los indicadores relacionados con producción y consumo sostenible",
  //   "id": "e46a96ae-e932-46af-90bf-92f61b457042",
  //   "name": "Producción y consumo sostenible",
  //   "category_id": "e46a96ae-e932-46af-90bf-92f61b457042"
  // },
  // {
  //   "metadata": {
  //     "version": "1.0.0"
  //   },
  //   "description": "Listado de los indicadores relacionados con energía y descarbonización",
  //   "id": "163fcd0f-060c-4191-aa1b-894e76232dad",
  //   "name": "Energía y descarbonización",
  //   "category_id": "163fcd0f-060c-4191-aa1b-894e76232dad"
  // },
  // {
  //   "metadata": null,
  //   "description": "",
  //   "id": "992fc9c5-4aee-44aa-b3de-91b8052d2876",
  //   "name": "Ciudades y comunidades",
  //   "icon_url": "https://indicator-data.s3.amazonaws.com/icon/industria.svg",
  //   "category_id": "992fc9c5-4aee-44aa-b3de-91b8052d2876"
  // },
  // {
  //   "metadata": {
  //     "version": "1.0.0"
  //   },
  //   "description": "Listado de los indicadores relacionados con recursos geológicos",
  //   "id": "d3d40f1a-a0eb-4d1f-af04-ea849fbb2139",
  //   "name": "Recursos geológicos",
  //   "category_id": "d3d40f1a-a0eb-4d1f-af04-ea849fbb2139"
  // }
];
